// extracted by mini-css-extract-plugin
export var disabled = "_2v-3";
export var growableInput = "_2v-0";
export var tagContainer = "_2v-2";
export var textInput = "_2v-1";